import $ from 'jquery';
import { debounce } from 'lodash';
export class Sticky {
    constructor() {
        this.selector = '.sticky';
        if ($(this.selector).length === 0)
            return;
        this.loop();
        this.resize();
        $(window).on('scroll', () => {
            this.loop();
        });
        $(window).on('resize', debounce(() => {
            this.resize();
        }, 250));
    }
    loop() {
        $(this.selector).each((_, element) => {
            if (window.scrollY > 0) {
                $(element).addClass('is-active');
            }
            else {
                $(element).removeClass('is-active');
            }
        });
    }
    resize() {
        $(this.selector).each((_, element) => {
            let $stickyTarget = $(element).find(".sticky-target");
            let $stickyPlaceholder = $(element).find(".sticky-placeholder");
            let stickyTargetHeight = $stickyTarget.outerHeight();
            $stickyPlaceholder.height(stickyTargetHeight);
        });
    }
}
;
